import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logout, logoutAndClearCache } from "../../action/logout-action";
import {
  ITalentPoolRoleState,
  TalentPoolRole,
} from "../../interfaces/talent-pool/i-talent-pool-role";

const initialState: ITalentPoolRoleState = {
  role: null,
  roleSelectionRequired: false,
};

const talentPoolRoleSlice = createSlice({
  name: "talentPoolRole",
  initialState,
  reducers: {
    setTalentPoolRole: (state, action: PayloadAction<TalentPoolRole>) => {
      state.role = action.payload;
      state.roleSelectionRequired = false;
    },
    markTalentPoolRoleUnset: (state) => {
      state.role = null;
      state.roleSelectionRequired = true;
    },
    clearTalentPoolRole: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(logoutAndClearCache, () => initialState);
  },
});

export const { setTalentPoolRole, markTalentPoolRoleUnset, clearTalentPoolRole } =
  talentPoolRoleSlice.actions;
export default talentPoolRoleSlice.reducer;
